import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { DEFAULT_TOOL_LAYOUT, normalizeToolLayoutPreferences } from '../viewerToolLayoutPreferences';
import ToolLayoutEditorPanel from './ToolLayoutEditorPanel';

export default function ViewerToolLayoutEditorDialog({ open, preferences, onSave, onClose }) {
  const [draft, setDraft] = React.useState(() => normalizeToolLayoutPreferences(preferences || DEFAULT_TOOL_LAYOUT));
  React.useEffect(() => { if (open) setDraft(normalizeToolLayoutPreferences(preferences || DEFAULT_TOOL_LAYOUT)); }, [open, preferences]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth aria-describedby="viewer-tool-layout-editor-description" PaperProps={{ sx: { bgcolor: '#071117', color: '#d7fbff', border: '1px solid rgba(110,239,255,0.22)', borderRadius: 2.5, backgroundImage: 'linear-gradient(145deg, rgba(14,28,38,0.98), rgba(5,13,19,0.98))' } }}>
      <DialogTitle sx={{ color: '#6eefff', fontWeight: 900, letterSpacing: 1.4 }}>MY TOOLS</DialogTitle>
      <DialogContent sx={{ display: 'grid', gap: 1.4 }}>
        <Typography id="viewer-tool-layout-editor-description" sx={{ color: 'rgba(215,251,255,0.66)', fontSize: 12 }}>
          Build a clean, fast workstation. Changes are previewed live and apply to this viewer as soon as you save.
        </Typography>
        <ToolLayoutEditorPanel value={draft} onChange={setDraft} />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2, position: 'sticky', bottom: 0, bgcolor: 'rgba(7,17,23,0.96)', borderTop: '1px solid rgba(110,239,255,0.12)' }}>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={() => onSave(normalizeToolLayoutPreferences(draft))} sx={{ color: '#021013', bgcolor: '#6eefff', '&:hover': { bgcolor: '#a8f6ff' } }}>Apply my tools</Button>
      </DialogActions>
    </Dialog>
  );
}
